// QA 答案內容區塊：
// - 字串：一般段落（字串內的 \n 會換行顯示）
// - { list, items }：條列清單，明確標示 ul／ol（項目文字不含「•」或「1.」前綴）
// - { subQa, body }：一則答案內的子問答（例如發票說明的 Q1、Q2），body 內可再放段落與清單
export type QaListItem = string | { title: string; body: string[] };
export type QaListBlock = { list: "ul" | "ol"; items: QaListItem[] };
export type QaSubQaBlock = { subQa: string; body: QaAnswerBlock[] };
export type QaAnswerBlock = string | QaListBlock | QaSubQaBlock;

export type QaItem = { QTwo: string; Ans: QaAnswerBlock[] };
export type MobileQaItem = { Question: string; Ans: QaAnswerBlock[] };

// 清單項目可用 **文字** 標示粗體（例如「**一般時段**：…，**$300**」），切成片段交給模板渲染，不使用 v-html
export type QaTextSegment = { text: string; bold: boolean };
export function parseEmphasis(text: string): QaTextSegment[] {
  return text
    .split("**")
    .map((part, i) => ({ text: part, bold: i % 2 === 1 }))
    .filter((seg) => seg.text !== "");
}
